import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const poll = {
        isLoading: false,
        // answerId: 0,
        // questionId: 0,
        init() {
            $(document).on('change', '.poll-answer', this, this.selectAnswer);
            $(document).on('click', '.poll-next-question-btn', this, this.nextQuestion);
            $(document).on('click', '.poll-prev-question-btn', this, this.prevQuestion);
            $(document).on('click', '#poll-form-btn', this, this.send);
            $(document).on('keyup', '.poll-answer-other-value', function() {
                if ($(this).val() != '') {
                    $('#poll-answer-' + $(this).data('id')).attr('checked', "checked");
                } else {
                    // $('#poll-answer-' + $(this).data('id')).attr('checked', false);
                }
            });
            $(document).on('click', '.poll-diploma-btn', function(e) {
                e.preventDefault();

                $('#poll_diploma_name').removeClass('is-invalid');

                if ($('#poll_diploma_name').val() == '') {
                    $('#poll_diploma_name').addClass('is-invalid');
                    return false;
                }

                window.open($(this).attr('href')+'&n='+$('#poll_diploma_name').val());
            });
        },
		selectAnswer(event) {
			const _this = event.data;
			event.preventDefault();
            const element = this;

            var id = $(element).val();
            var qid = $(element).data('qid');
            var pid = $(element).data('pid');

            // _this.answerId = id;
            // _this.questionId = qid;

            $('.answer-info-text').hide();
            $('#answer-info-text-' + id).show();
            
        },
		nextQuestion(event) {
			const _this = event.data;
			event.preventDefault();
            const element = this;
            
            var answerId = 0;
            var answersIds = [];

            if ($(element).data('question-type') == '1') {
                var errors = false;
                
                $('.poll-multiple-answers').each(function(index, item) {
                    var answerValue = $('input[name="poll-answer-'+$(item).data('id')+'"]:checked').val();
                    if (answerValue) {
                    
                    } else {
                        errors = true;
                    }
                });

                if (errors) {
                    Swal.fire({
                        html: 'Va rog selectati raspunsurile!'
                    });
                    return false;
                }
            } else if($(element).data('question-type') == '2') {
                var answerWithOtherValueError = false;

                var checkedAnswers = $("input[name='poll-answer-"+$(element).data('qid')+"']:checked");
                checkedAnswers.each(function() {
                    if ($(this).data('other-value') == '1') {
                        if($('#poll-answer-other-value-' + $(this).val()).val() == '') {
                            answerWithOtherValueError = true;
                        }
                        answersIds.push($(this).val());
                    } else {
                        answersIds.push($(this).val());
                    }
                });

                if (answersIds.length < 1) {
                    Swal.fire({
                        html: 'Va rog selectati un raspuns!'
                    });
                    return false;
                }
                if (answerWithOtherValueError) {
                    Swal.fire({
                        html: 'Va rog completati raspunsul!'
                    });
                    return false;
                }

            } else {
                var answerId = $('.poll-answer:checked').val();
                if (answerId) {
                    
                } else {
                    Swal.fire({
                        html: 'Va rog selectati un raspuns!'
                    });
                    return false;
                }
    
                if ($('#poll-answer-' + answerId).data('other-value') == '1') {
                    if($('#poll-answer-other-value-' + answerId).val() == '') {
                        Swal.fire({
                            html: 'Va rog completati raspunsul!'
                        });
                        return false;
                    }
                }
            }


            if (_this.isLoading) {
                return false;
            }

            _this.isLoading = true;
            $(element).find('i').show();

            var values='';
            values+='module_id=' + $(element).data('mid');
            values+='&poll_id=' + $(element).data('id');
            values+='&question_id=' + $(element).data('qid');
            values+='&answer_id=' + answerId;
            values+='&answers_ids=' + answersIds.join(',');
            values+='&other_value=' + ($('#poll-answer-' + answerId).data('other-value') == '1' ? $('#poll-answer-other-value-' + answerId).val() : '');
            values+='&_token=' + $('meta[name="csrf-token"]').attr("content");
            if ($(element).data('question-type') == '2') {
                var checkedAnswers = $("input[name='poll-answer-"+$(element).data('qid')+"']:checked");
                checkedAnswers.each(function() {
                    if ($(this).data('other-value') == '1') {
                        values+='&answer_'+$(this).val()+'=' + $('#poll-answer-other-value-' + $(this).val()).val();
                    }
                });
            }
            if ($(element).data('question-type') == '1') {
                $('.poll-multiple-answers').each(function(index, item) {
                    var answerValue = $('input[name="poll-answer-'+$(item).data('id')+'"]:checked').val();
                    if (answerValue) {
                        values+='&answer_'+$(item).data('id')+'=' + answerValue;
                    }
                });
            }
			$.ajax({
                type: "POST",
                url: baseURL + '/poll/answer',
                data: values,
                success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 1) {

                        if (response.redirect != 1) {
                            $('html, body').animate({
                                scrollTop: $(".question-wrapper").offset().top - 130
                            }, 300);
                        }

                        if (response.show_form == 1) {
                            $('#poll-main-container').html(response.html);
                            return false;
                        }

                        if (response.redirect == 1) {
                            window.location = response.redirect_url;
                            return;
                        }

                        // _this.answerId = 0;
                        // _this.questionId = 0;
						$('#question-wrapper-' + $(element).data('id')).html(response.html);

						return false;
					}

                    Swal.fire({
                        // icon: 'success',
                        // title: 'Success!',
                        html: response.message
                    });
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
        },
        prevQuestion(event) {
            const _this = event.data;
			event.preventDefault();
            const element = this;

            var values='';
            values+='module_id=' + $(element).data('mid');
            values+='&poll_id=' + $(element).data('id');
            values+='&question_id=' + $(element).data('qid');
            values+='&_token=' + $('meta[name="csrf-token"]').attr("content");
			$.ajax({
	            type: "POST",
	            url: baseURL + '/poll/prev-question',
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 1) {
                        // _this.answerId = 0;
                        // _this.questionId = 0;
						$('#question-wrapper-' + $(element).data('id')).html(response.html);

						return false;
					}

                    Swal.fire({
                        // icon: 'success',
                        // title: 'Success!',
                        html: response.message
                    });
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();
            const element = this;

            if (_this.isLoading) {
                return false;
            }

            var errors = false
            $('.poll-form').find('.form-control').removeClass('is-invalid');
            $('.poll-form').find('.form-check-input').removeClass('is-invalid');

            if ($('#poll_name').val() == '') {
                $('#poll_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#poll_email').val() == '') {
                $('#poll_email').addClass('is-invalid');
                errors = true;
            }
            if (!$('#poll_terms_and_conditions').is(":checked")) {
                $('#poll_terms_and_conditions').addClass('is-invalid');
                errors = true;
            }
            if (!$('#poll_certificate').is(":checked")) {
                $('#poll_certificate').addClass('is-invalid');
                errors = true;
            }

            if(errors) {
                return false;
            }

            _this.isLoading = true;
            $(element).find('i').show();

            var values='';
            values+='poll_id=' + $(element).data('id');
            values+='&name=' + $('#poll_name').val();
            values+='&email=' + $('#poll_email').val();
            values+='&newsletter=' + ($('#poll_newsletter').is(":checked")?1:0);
            values+='&_token=' + $('meta[name="csrf-token"]').attr("content");
			$.ajax({
	            type: "POST",
	            url: baseURL + '/poll/send-form',
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 1) {

                        window.location = response.redirect_url;

                        // var currentUrl = new URL(window.location.href);
                        // var searchParams = new URLSearchParams(currentUrl.search);
                        // searchParams.set('success', 'true');
                        // currentUrl.search = searchParams.toString();
                        // window.location.href = currentUrl.toString();

						return false;
					}

                    Swal.fire({
                        // icon: 'success',
                        // title: 'Success!',
                        html: response.message
                    });
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
        }
    }

    if ($('#poll-main-container').length) {
        poll.init();
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/modules/poll.js